import { useTranslation } from 'react-i18next'
import EmptyView from '../../customMui/EmptyView'

export default function NoAccountsFound() {
  const texts = useTranslation('accountList').t

  return <EmptyView label={texts('no_data_label')} />
}